import { render, staticRenderFns } from "./ViewMethodDealingWithMissingData.vue?vue&type=template&id=12ca3f96&scoped=true"
import script from "./ViewMethodDealingWithMissingData.vue?vue&type=script&lang=js"
export * from "./ViewMethodDealingWithMissingData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ca3f96",
  null
  
)

export default component.exports